module.exports = __webpack_public_path__ + "static/home-page-background-e75526c7c73756dbfc8284f15102d784.png";